'use client'
import Script from 'next/script'
import React, {useCallback, useEffect, useState} from 'react'

import {GTM_ID} from '../../src/shared/utils/gtm'

const GoogleTagManager = () => {
  const [cookieConsent, setCookieConsent] = useState(false)

  const handleConsentEvent = useCallback((e: Event) => {
    const customEvent = e as CustomEvent
    if (customEvent.detail?.consent) {
      setCookieConsent(customEvent.detail.consent === 'GRANTED')
    }
  }, [])

  useEffect(() => {
    const localCookieConsent = localStorage.getItem('cookieConsent') as
      | 'DENIED'
      | 'GRANTED'

    if (localCookieConsent === 'GRANTED') {
      setCookieConsent(true)
    }
    window.addEventListener('consentUpdated', handleConsentEvent)
    return () => {
      window.removeEventListener('consentUpdated', handleConsentEvent)
    }
  }, [handleConsentEvent])

  return cookieConsent ? (
    <Script id="google-tag-manager" strategy="afterInteractive">
      {`
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `}
    </Script>
  ) : null
}

export default GoogleTagManager
